import { DeviceOperationalState } from '@/__generated__/graphql';
import { getDeviceOperationalStateAttributes } from '@/utils/attributes/deviceOperationalState';
import { msg, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { VisibilityOff } from '@mui/icons-material';
import { Chip, Tooltip } from '@mui/material';
import { type FC } from 'react';

interface Props {
  operationalState?: DeviceOperationalState | null;
}

/**
 * AMARU-597: marca un acceso concedido que el cliente aún NO ve por su estado operacional
 * (fuera de CLIENT_OPERATIONAL_STATES). Solo aparece en la vista de admin (Capta): para un
 * caller cliente la lista de accesos ya viene filtrada, así que estos registros no se muestran.
 */
const ClientHiddenChip: FC<Props> = ({ operationalState }) => {
  const { _, i18n } = useLingui();
  const stateLabel = operationalState
    ? getDeviceOperationalStateAttributes(operationalState, i18n).label
    : null;

  return (
    <Tooltip
      title={
        stateLabel ? (
          <Trans>
            El usuario tiene acceso, pero aún no verá este dispositivo: su estado operacional (
            {stateLabel}) no está entre los visibles para clientes.
          </Trans>
        ) : (
          <Trans>
            El usuario tiene acceso, pero aún no verá este dispositivo por su estado operacional.
          </Trans>
        )
      }
    >
      <Chip
        size="small"
        color="warning"
        variant="outlined"
        icon={<VisibilityOff />}
        label={_(msg`Oculto para el cliente`)}
      />
    </Tooltip>
  );
};

export default ClientHiddenChip;
